if ($('#inventory-level-isbns').length) {
  var cart_products_inventory = [];
  const productInventory = $('#product-inventory-level-label');
  
  // Inventory Product Template per Product Label
  const inventoryProductTemplate = `
    <div class="inventory-product-template-container">
      <span class="inventory-product-template-icon">
        <svg viewBox="0 0 20 20" focusable="false" aria-hidden="true" style="width: 22px; fill: rgb(239,124,13);">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17.5a7.452 7.452 0 01-4.339-1.394L16.106 5.661A7.452 7.452 0 0117.5 10c0 4.136-3.364 7.5-7.5 7.5zm0-15c1.617 0 3.113.52 4.339 1.394L3.894 14.339A7.451 7.451 0 012.5 10c0-4.136 3.364-7.5 7.5-7.5zM10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0z"></path>
        </svg>
      </span>
      <p class="inventory-product-template-text">    
          Sold out
       </p>
  </div>`
  const inventoryTemplate = Handlebars.compile(inventoryProductTemplate);
  // Inventory Product Level Global Warning
  
  const hasOutOfStock = false; 
  const OOSTemplate = `<div style="width: 100%; margin: 15px 0;">
      <div class="inventory-product-template-container" >
         <div class="inventory-oos-template-icon">
           <svg viewBox="0 0 50 50" fill="none" focusable="false" aria-hidden="true" style="color: rgb(239,124,13)">
             <path d="M49 25c0 13.255-10.745 24-24 24S1 38.255 1 25 11.745 1 25 1s24 10.745 24 24z" stroke-width="2" stroke="currentColor"></path>
             <path d="M25 11v19" stroke-width="2" stroke-linecap="square" stroke="currentColor"></path>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M25 39a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="currentColor"></path>
          </svg>
         </div>
         <div>
           <h4>Out of stock</h4>
           <p class="inventory-oos-template-text">Some items are no longer available. Please update your cart.</p>
         </div>
        </div>
    </div>`;
    const hasOutOfStockTemplate = Handlebars.compile(OOSTemplate);
  
    // Get ISBN per Product added to the cart
    const isbns = $('#inventory-level-isbns').attr('data-isbn') 
        ? $('#inventory-level-isbns').attr('data-isbn').split(',') 
        : [];
   
    // Ajax Setup
    // PROD: https://shopifyapi.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-Workman/
    const api_info = `https://shopifyapi.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-Workman/`;
    // Prod https://shopifyapi.hbgusa.com/hbg-shopify-api/api/inventory/set/isbn/Shopify-Workman/
    const api_set = `https://shopifyapi.hbgusa.com/hbg-shopify-api/api/inventory/set/isbn/Shopify-Workman/`;
    const settings = {
        "async": true,
        "crossDomain": true,
        "method": "GET",
        "headers": {
          "Content-Type": "application/json",
        },
        "processData": true,
    };
    
    var cart_products_inventory = [];
    if(isbns && isbns.length) {
       let showGlobalWarning = false;
      isbns.forEach(async isbn => {
        const $element = $(`div.product-inventory-level-label[data-isbn='${isbn}']`);
        const isPreorder = $element.attr('data-preorder');
        if(isPreorder === 'true') return; 

        settings.url = `${api_info}${isbn}`;
        $.ajax(settings).then( product_inventory => {
          // Display Global Warning
          if (product_inventory && !product_inventory.inventoryLevel) {
            if(!showGlobalWarning) {
              showGlobalWarning = true;
              $('#oos-warning').append(hasOutOfStockTemplate());
            }
            //const $element = $(`div.product-inventory-level-label[data-isbn='${isbn}']`);
            if( $element ) {
              $element.append(inventoryTemplate());
            }
          }
        });
        // Update Shopify Inventory
        settings.url = `${api_set}${isbn}`;
        $.ajax(settings).then( product_inventory => {
          // Display Global Warning
         // console.log('Shopify Updated');
        });
      });
    }
}
